import React from 'react'

const Headword = (props) => {
  
  return (
    <div>
   
     

    <div className="about_section">
    <div className="about_width">
 <div className="title">{props.name} </div>
 
 
 
 </div>
 
 </div>
 
    </div>
  )
}

export default Headword